//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import constant from '~/const';
import Filters from './TableFilters.vue';

import tableConfig from './tableConfig';

export default {
  components: {
    Filters,
  },

  data() {
    return {
      tableConfig,
      constant,
    };
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      this.loadDataAction(),
      this.loadRentersAction(),
      this.loadCurrencies(),
    ]);
    this.setGeneralLoader(false);
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),

    ...mapState('cryptomatsOrders', ['page', 'pages', 'filters', 'data']),
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
    ]),
    ...mapActions('cryptomatsOrders', {
      loadDataAction: 'loadOrders',
      confirmOrderAction: 'confirmOrder',
      rejectOrderAction: 'rejectOrder',
    }),
    ...mapActions('cryptomatsRenters', {
      loadRentersAction: 'loadRenters',
    }),
    ...mapActions('tradersCurrencies', {
      loadCurrencies: 'loadData',
    }),

    async loadData(data = {}) {
      this.setGeneralProgress(true);
      await this.loadDataAction(data);
      this.setGeneralProgress(false);
    },

    applyFilters() {
      const { page } = this;
      if (page > 1) {
        this.setPageAction(1);
        this.$router.replace({ query: {} });
      }

      this.loadData();
    },

    setPage(value) {
      this.setPageAction(value);

      const extendedRequestData = {
        getTotal: false,
      };

      this.loadData(extendedRequestData);
    },

    acceptOrder() {
      this.confirmAction({
        title: 'Confirm order',
        text: 'Are you sure you want to confirm this order?',
        callback: async () => {
          this.setGeneralLoader(true);
          try {
            await this.confirmOrderAction();
            this.setSuccessNotification('You have successfuly confirmed the order');
            this.loadData();
          } catch (error) {
            this.setErrorNotification('Unable to confirm the order');
          }
          this.setGeneralLoader(false);
        },
      });
    },

    rejectOrder() {
      this.confirmAction({
        title: 'Reject order',
        text: 'Are you sure you want to reject this order?',
        callback: async () => {
          this.setGeneralLoader(true);
          try {
            await this.rejectOrderAction();
            this.setSuccessNotification('You have successfuly rejected the order');
            this.loadData();
          } catch (error) {
            this.setErrorNotification('Unable to reject the order');
          }
          this.setGeneralLoader(false);
        },
      });
    },
  },
};
